<template>
  <div class="min-h-screen flex items-center justify-center bg-background">
    <div class="text-center">
      <div v-if="error" class="max-w-md mx-auto">
        <AlertBanner variant="error" class="mb-4">
          <p class="text-sm">{{ error }}</p>
        </AlertBanner>
        <router-link
          :to="localePath('Login')"
          class="font-medium text-primary hover:text-primary/80"
        >
          {{ $t('auth.backToLogin') }}
        </router-link>
      </div>
      <div v-else>
        <svg
          class="animate-spin h-8 w-8 text-primary mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          ></path>
        </svg>
        <p class="mt-4 text-muted-foreground">{{ $t('auth.signingYouIn') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../../stores/auth'
import { useLocalePath } from '../../composables/useLocalePath'
import { safeRedirect } from '../../router/authRoutes'
import AlertBanner from '../../components/AlertBanner.vue'

const router = useRouter()
const { t } = useI18n()
const authStore = useAuthStore()
const { localePath } = useLocalePath()

const error = ref(null)

onMounted(async () => {
  const hash = location.hash.slice(1)
  const params = new URLSearchParams(hash)
  const token = params.get('token')
  const refreshToken = params.get('refresh_token')

  if (token) {
    history.replaceState(history.state, '', location.pathname)

    authStore.applyTokens({ token, refresh_token: refreshToken })

    try {
      await authStore.fetchUser()
      if (authStore.user && authStore.user.username === null) {
        router.push('/complete-username')
      } else {
        const redirectPath = sessionStorage.getItem('authRedirect')
        sessionStorage.removeItem('authRedirect')
        router.push(safeRedirect(router, redirectPath) || localePath('Home'))
      }
    } catch {
      error.value = t('auth.failedToLoadProfile')
      authStore.clearTokens()
    }
  } else {
    error.value = t('auth.noTokenReceived')
  }
})
</script>
